import { createApiActionTypes, fetchReducer } from 'iqvia-shared';
import reduceReducers from 'reduce-reducers';

import apiNameEnums from '../../../Enums/apiNames';

export const defaultState = {
  activityTypes: [],
  isLoading: false,
  error: null,
  isError: false,
};
export const getActivityTypesActiontypes = createApiActionTypes(apiNameEnums.GET_ACTIVITY_TYPES);

const sharedData = (state = defaultState, { type, payload }) => {
  switch (type) {
    case getActivityTypesActiontypes.request.type: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case getActivityTypesActiontypes.success.type: {
      return {
        ...state,
        isLoading: false,
        activityTypes: payload,
        isError: false,
        error: null,
      };
    }

    case getActivityTypesActiontypes.failure.type: {
      return {
        ...state,
        isLoading: false,
        activityTypes: [],
        isError: true,
        error: payload,
      };
    }

    default:
      return state;
  }
};

export default reduceReducers(sharedData, fetchReducer(apiNameEnums.GET_ACTIVITY_TYPES));



// WEBPACK FOOTER //
// ./src/JourneyBuilder/SendOptimizer/reducers/sharedData.js